(function () {
  var svgIndex = 0;

  function update(svg) {
    if (svg.dataset.uniqueIdsApplied) return false;

    var ids = {};
    svg.querySelectorAll("[id]").forEach(function (element, index) {
      ids[element.id] = "okendo-svg-" + ++svgIndex + "-" + index;
      element.id = ids[element.id];
    });

    svg.querySelectorAll("*").forEach(function (element) {
      Array.from(element.attributes).forEach(function (attribute) {
        var value = attribute.value;
        Object.keys(ids).forEach(function (id) {
          value = value.replaceAll("#" + id, "#" + ids[id]);
        });
        if (value !== attribute.value) element.setAttribute(attribute.name, value);
      });
    });

    svg.dataset.uniqueIdsApplied = "true";
    return true;
  }

  function scan(root) {
    var updated = false;
    var svg = root.closest && root.closest(".okeReviews svg");
    if (svg) updated = update(svg);
    if (root.querySelectorAll) {
      root.querySelectorAll(".okeReviews svg").forEach(function (item) {
        updated = update(item) || updated;
      });
    }
    return updated;
  }

  if (scan(document)) return;

  var observer = new MutationObserver(function (records) {
    var updated = false;
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        updated = scan(node) || updated;
      });
    });
    if (updated) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
